/* eslint-disable */
import axios from 'axios';
import dotenv from 'dotenv';
import jwt from 'jsonwebtoken';
import storage from './storage';
import { KEY_LOCAL_STORAGE } from './../const';
dotenv.config();

var apiIP = '';
if (process.env.VUE_APP_IP_API) {
  apiIP = `${process.env.VUE_APP_IP_API}${
    process.env.VUE_APP_PORT_REST ? ':' + process.env.VUE_APP_PORT_REST : ''
  }`;
} else {
  apiIP = 'https://api-hero.clubecerto.com.br/';
}

var idEmpresa = process.env.VUE_APP_WL;

export default {
  async getIP() {
    try {
      const { data } = await axios.get('https://api.ipify.org?format=json');
      return data.ip;
    } catch (error) {
      console.error(error);
      return 'Não foi possível localizar o ip';
    }
  },
  getDecoded() {
    const token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
    if (token) return jwt.decode(token);
    else return null;
  },
  getEnvIconeCarregando() {
    return process.env.VUE_APP_ICONE_CARREGANDO;
  },
  getJson(jsonName) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint =
          apiIP + '/g/buscaJson/' + process.env.VUE_APP_SITE + '/' + jsonName;

        axios
          .get(endpoint)
          .then(function(response) {
            resolve(response.data);
          })
          .catch(function(error) {
            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },
  getAll(controllerName, extraParams, action = 'list') {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == '') {
              endpoint = endpoint + 'Page/' + extraParams.PageNumber;
            } else {
              endpoint = endpoint + '/' + extraParams.PageNumber;
            }
          }
        endpoint = endpoint
          .replace('idEmpresa=null', 'idEmpresa=' + idEmpresa)
          .replace('idEmpresa=undefined', 'idEmpresa=' + idEmpresa);

        var token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
        axios
          .get(endpoint, {
            headers: {
              Authorization: token,
            },
          })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            if (error.response.data.error) {
              console.error(error.response.data.error);
              reject(error.response.data.error);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getOne(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/${extraParams.PrimaryKey}/${extraParams.PageNumber}`;

        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  getFilter(controllerName, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        const endpoint = `${apiIP}/${controllerName}/filter/${extraParams.SearchText}?page=${extraParams.PageNumber}`;

        axios
          .get(endpoint, {
            extraParams,
          })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            if (error.response.data.error) {
              reject(error.response.data.error);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  post(controllerName, action = 'create', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;

        if (extraParams)
          if (extraParams.PageNumber != undefined) {
            if (action == '') {
              endpoint = endpoint + 'Page/' + extraParams.PageNumber;
            } else {
              endpoint = endpoint + '/' + extraParams.PageNumber;
            }
          }

        data.idEmpresa = idEmpresa;

        var token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
        axios
          .post(endpoint, data, {
            headers: {
              Authorization: token,
            },
          })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            if (error.response) {
              if (error.response.status == 401) {
                reject(
                  'Sua sessão expirou, efetue login novamente para completar a ação',
                );
              }
              if (error.response.data.error) {
                console.error(error);
                reject(error.response.data.error.errorMessage);
              } else {
                reject('Ação não Encontrada');
              }
            } else {
              reject('Erro Sistemico');
            }
          });
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },

  login(controllerName, action = 'login', data) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        data.idEmpresa = idEmpresa;

        var basicAuth = 'Basic ' + btoa(JSON.stringify(data));

        axios
          .post(
            endpoint,
            {},
            {
              headers: {
                Authorization: basicAuth,
              },
            },
          )
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            if (error.response.data) {
              if (error.response.data.error) {
                console.error(error);
                if (error.response.data.error)
                  reject(error.response.data.error);
                else reject();
              } else {
                reject(error);
              }
            }
            if (error) {
              reject();
            }
          });
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },

  upload(controllerName, action, data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${idEmpresa}/${action}`;

        axios
          .post(endpoint, data, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(function(response) {
            resolve(response.data);
          })
          .catch(function(error) {
            if (error.response.data.error) {
              reject(error.response.data.error);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  },

  put(controllerName, action = 'update', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        data.idEmpresa = idEmpresa;
        var token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);

        axios
          .put(endpoint, data, {
            headers: {
              Authorization: token,
            },
          })
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            if (error.response.data.error) {
              console.error(error.response);
              reject(error.response.data.error);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  delete(controllerName, action = 'update', data, extraParams) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;
        var token = storage.lerStorage(KEY_LOCAL_STORAGE.USER_TOKEN);
        data = {
          headers: {
            Authorization: token,
          },
        };

        data.idEmpresa = idEmpresa;

        axios
          .delete(endpoint, data)
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            if (error.response.data.error) {
              reject(error.response.data.error);
            } else {
              reject('Ação não Encontrada');
            }
          });
      } catch (e) {
        reject(e);
      }
    });
  },

  validaToken(token, controllerName, action) {
    return new Promise((resolve, reject) => {
      try {
        var endpoint = `${apiIP}/${controllerName}/${action}`;

        axios
          .post(
            endpoint,
            {
              front: true,
              idEmpresa: idEmpresa,
            },
            {
              headers: {
                Authorization: token,
              },
            },
          )
          .then(function(response) {
            resolve(response);
          })
          .catch(function(error) {
            console.error(error);
            resolve({
              data: {
                result: false,
              },
            });
          });
      } catch (e) {
        reject(e);
      }
    });
  },
};
